import BlogPostPreview from "./BlogPostPreview";
// import AniLink from "gatsby-plugin-transition-link/AniLink";
import React from "react";

function BlogPostGrid(props) {
  return (
    <>
      {props.nodes &&
        props.nodes.map((node) => (
          <div key={node.id}>
            <BlogPostPreview {...node} buttonText={props.buttonText} isInList />
          </div>
        ))}
      {/* {props.browseMoreHref && (
        <div>
          <AniLink fade to={props.browseMoreHref}>
            Browse more
          </AniLink>
        </div>
      )} */}
    </>
  );
}

BlogPostGrid.defaultProps = {
  title: "",
  nodes: [],
  browseMoreHref: "",
};

export default BlogPostGrid;
